// extracted by mini-css-extract-plugin
module.exports = {"ArticleContainer":"Article_ArticleContainer__3xB6z","Article":"Article_Article__pamKF","ArticleFeatured":"Article_ArticleFeatured__1x5lZ"};